import React from 'react';

import { Container } from 'reactstrap';

const AccessDenied: React.FC = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h4>You don&apos;t have permission to view this page.</h4>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AccessDenied;
